import { Button } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled.h2`
  font-weight: normal;
  margin-bottom: ${tokens.space.large};
`;

type ContentProps = {
  showInformation?: boolean;
};

export const Content = styled.div<ContentProps>`
  display: grid;
  grid-gap: ${tokens.space.regular};
  grid-template-columns: ${({ showInformation }): string => (showInformation ? '1fr 1fr' : '1fr')};

  ${tokens.mediaQueries.s} {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const SubscribeButton = styled(Button)`
  white-space: nowrap;
`;

export const Description = styled.p`
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.grayDarkest};
  margin: 0;
`;
